import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { Table } from "primeng/table";
import { emit } from "process";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { ApiService } from "src/app/api.service";
import { CategoryLan } from "src/app/shared/models/CategoryLan";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";
import { MatNatItemQtyVO } from "src/app/shared/models/MatNatItemQtyVO";
import { MatNatReqStsHVO } from "src/app/shared/models/MatNatReqStsHVO";
import { TovpilCrudService } from "src/app/utils/tovpil-crud-service";
import { TovpilFilesService } from "src/app/utils/tovpil-files.service";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { UrlBuilderService } from "src/app/utils/tovpil-url-builder.service";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";

@Component({
  selector: "app-mat-nat-req-dtl",
  templateUrl: "./mat-nat-req-dtl.component.html",
  styleUrls: ["./mat-nat-req-dtl.component.scss"],
  providers: [MessageService, ConfirmationService, TovpilLanguageService],
})
export class MatNatReqDtlComponent implements OnInit {
  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};

  /** DIALOG */
  displayModal: boolean = false;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** COMPONENT */
  listOrders: MatNatItemQtyVO[];

  /**
   * The constructor initializes various services and sets up user preferences based on authentication
   * and security settings.
   * @param {MessageService} messageService - The `messageService` parameter is likely a service used
   * for displaying messages or notifications to the user in the application. It could be responsible
   * for handling communication of messages between different components or services within the
   * application.
   * @param {ApiService} apiService - The `apiService` parameter in the constructor is likely a service
   * that handles API requests and responses in your application. It is used to communicate with
   * backend servers, fetch data, send data, and perform other operations related to interacting with
   * APIs.
   * @param {ActivatedRoute} route - The `route` parameter in the constructor is of type
   * `ActivatedRoute` which is a service provided by Angular that gives you access to information about
   * a route associated with a component that is loaded in an outlet. It allows you to access route
   * parameters, query parameters, and other information related to the current
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter in
   * the constructor is a service that handles user authentication within the application. It likely
   * provides methods for user login, logout, and authentication status checks. This service is
   * essential for managing user sessions and ensuring that users have the necessary permissions to
   * access certain parts of the application.
   * @param {UrlBuilderService} urlBuilderService - The `urlBuilderService` is a service that helps in
   * building and managing URLs within the application. It is commonly used for constructing URLs for
   * API endpoints, routing within the application, and handling dynamic URL parameters. This service
   * abstracts the complexity of URL construction and provides methods to easily generate URLs based on
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter in the
   * constructor is likely a service that handles CRUD (Create, Read, Update, Delete) operations for
   * data in the application. It is used to interact with the backend API to perform operations such as
   * creating new data, retrieving data, updating existing data
   * @param {FormBuilder} fb - The `fb` parameter in the constructor is an instance of `FormBuilder`
   * from Angular Forms. It is used to create form controls and groups for reactive forms in Angular
   * applications.
   * @param {TovpilUtilsService} tovUtilsService - The `tovUtilsService` parameter in the constructor
   * is likely a service that provides utility functions or helper methods related to the functionality
   * of the application. It could contain methods for common tasks such as data manipulation,
   * validation, formatting, or any other utility functions that are used across different parts of the
   * application
   * @param {UserPreferencesService} userPreferencesService - The `userPreferencesService` parameter in
   * the constructor is a service that is responsible for managing and storing user preferences within
   * the application. It likely provides methods to retrieve, update, and store user-specific settings
   * and configurations, such as language preferences, theme choices, or any other custom settings that
   * users can personalize
   * @param {Router} router - The `router` parameter in the constructor is used for routing in Angular
   * applications. It provides navigation and URL manipulation capabilities in your application. You
   * can use it to navigate to different components or routes within your application.
   * @param {TovpilFilesService} filesService - The `filesService` parameter in the constructor is
   * likely a service that handles file-related operations in the application. This service may be
   * responsible for tasks such as uploading files, downloading files, managing file storage, and
   * handling file-related configurations.
   * @param {TovpilLanguageService} translationService - The `translationService` parameter in the
   * constructor is likely used for handling language translation within the application. It is
   * injected as a dependency to provide translation services such as translating text or messages
   * displayed in the user interface into different languages based on user preferences or settings.
   * This service helps in making the application more user
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService
  ) {
    this.createDataForm();
    this.initConfigs();

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
   * The `createDataForm` function in TypeScript creates a reactive form with specific form controls.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedSequence: new FormControl({ value: null, disabled: true }),
      selectedYear: new FormControl(null),
      selectedSupplSeq : new FormControl(null),
      selectedOrderSeq: new FormControl(null),
      selectedApplicant: new FormControl({ value: null, disabled: true }),
      selectedRequired: new FormControl({ value: null, disabled: true }),
      selectedReqDate: new FormControl({ value: null, disabled: true }),
      selectedLanguage: new FormControl({ value: null, disabled: true }),
      selectedStatus: new FormControl({ value: null, disabled: true }),
      selectedSentDate: new FormControl({ value: null, disabled: true }),
      selectedReceiveDate: new FormControl({ value: null, disabled: true }),
      selectedComments: new FormControl({ value: null, disabled: true }),
    });

    // console.debug(
    //   "MatNatReqDtlComponent - REACTIVE FORM: ",
    //   JSON.stringify(this.globalUserDataForm.getRawValue(), null, 2)
    // );
  }

  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  ngOnInit(): void {
    let order : MatNatReqStsHVO;

    this.route.queryParams.subscribe((params) => {
      order = JSON.parse(decodeURIComponent(params.order));
    });

    this.globalUserDataForm.patchValue({
      selectedYear: order.orderYear,
      selectedOrderSeq: order.orderSeq,
      selectedSupplSeq: order.supplSeq,
      selectedApplicant: order.storeName,
      selectedRequired: order.supplName,
      selectedReqDate: order.reqDate,
      selectedLanguage: order.language,
      selectedStatus: order.hdrStatus,
      selectedSentDate: order.maxSentDate,
      selectedReceiveDate: order.maxRcvDate,
      selectedComments: this.formatComments(order),
      selectedSequence : order.orderYear+"-"+order.orderSeq+"-"+order.supplSeq
    });

    this.getSecurity();
  }

  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE EN CASO DE QUE SEA NULL
    if (securityControl === null || Object.keys(securityControl).length === 0) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }

    await this.getTranslatedLabels();
    await this.getData();
  }

  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  async getData() {
    const year = this.globalUserDataForm.get('selectedYear').value;
    const orderSeq = this.globalUserDataForm.get('selectedOrderSeq').value;
    const supplSeq = this.globalUserDataForm.get('selectedSupplSeq').value;

    const orders = await this.apiService.getMaterialGetReqItemsQuantity({
      year: year,
      orderSeq: orderSeq,
      supplSeq: supplSeq,
    });
    this.listOrders = orders;
    this.blocked = false;
  }

  async back(){
    // Para cuando se usa solo responsivo
    // this.router.navigate(["sc/materials/matNatReqLst"]);

    // Para monolitico
    this.router.navigate(["materials/matNatReqLst"]);
  }

  exportPdf() {
    try {
      if (this.listOrders === null || this.listOrders.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const itemId  = this.translations.lbl_item + " " + this.translations.lbl_id;
        const itemName  = this.translations.lbl_name + " " + this.translations.lbl_item;
        const requestedQty = this.translations.lbl_quantity + " " + this.translations.lbl_requested;
        const approvedQty  = this.translations.lbl_quantity + " " + this.translations.lbl_approved;
        const totalSent = this.translations.lbl_total + " " + this.translations.lbl_sent;
        const totalReceived = this.translations.lbl_total + " " + this.translations.lbl_received;

        const filteredJSON = this.listOrders.map((order) => ({
          [itemId]: order ? (order.itemId || 'S/N') : 'S/N',
          [itemName]: order ? (order.itemName || 'S/N') : 'S/N',
          [requestedQty]: order ? (order?.reqQty || 0) : 0,
          [approvedQty]: order ? (order?.appQty || 0) : 0,
          [totalSent]: order ? (order?.sentQty || 0) : 0,
          [totalReceived]: order ? (order?.rcvQty || 0) : 0,
        }));

        const keysArray = filteredJSON.map((order) => Object.keys(order));
        const valuesArray = filteredJSON.map((order) => Object.values(order));

        let fileName = `${this.translations.lbl_detail}_${this.translations.lbl_orders_request}_${this.globalUserDataForm.get('selectedApplicant').value}_`;
        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_pdf}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  exportExcel() {
    try {
      if (this.listOrders === null || this.listOrders.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const itemId  = this.translations.lbl_item + " " + this.translations.lbl_id;
        const itemName  = this.translations.lbl_name + " " + this.translations.lbl_item;
        const requestedQty = this.translations.lbl_quantity + " " + this.translations.lbl_requested;
        const approvedQty  = this.translations.lbl_quantity + " " + this.translations.lbl_approved;
        const totalSent = this.translations.lbl_total + " " + this.translations.lbl_sent;
        const totalReceived = this.translations.lbl_total + " " + this.translations.lbl_received;

        const filteredJSON = this.listOrders.map((order) => ({
          [itemId]: order ? (order.itemId || 'S/N') : 'S/N',
          [itemName]: order ? (order.itemName || 'S/N') : 'S/N',
          [requestedQty]: order ? (order?.reqQty || 0) : 0,
          [approvedQty]: order ? (order?.appQty || 0) : 0,
          [totalSent]: order ? (order?.sentQty || 0) : 0,
          [totalReceived]: order ? (order?.rcvQty || 0) : 0,
        }));

        let fileName = `${this.translations.lbl_detail}_${this.translations.lbl_orders_request}_${this.globalUserDataForm.get('selectedApplicant').value}_`;
        this.filesService.tovpilExportXLSX(filteredJSON, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to Excel:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_excell}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  formatComments(order: any) {
    let comments = order.internalComments ?? "";
    comments += " ";
    comments += order.vendorComments ?? "";
    comments += " ";
    comments += order.itemComments ?? "";
    comments += " ";
    comments += order.folioNumbers ?? "";

    return comments;
  }
}
